import { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Divider, Tab, Tabs } from '@mui/material';
import { PageOuterContainer } from '../../../root-components/layouts/page-outer-container';
import { PageHeading } from '../../presentation-components/display-elements-components/page-heading';
import { SurveyQuestionsPage } from './survey-questions-page';
import { SurveyQuestionGroupsPage } from './survey-question-groups-page';

type LibraryTabId = 'questions' | 'sets';

/**
 * The reusable building blocks behind surveys, in one place: individual questions
 * and the question sets that arrange them. Everyday survey building happens on the
 * survey hub; this area is for maintaining the shared library.
 */
export const SurveyLibraryPage = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const requestedTab = searchParams.get('tabId') as LibraryTabId | null;
  const activeTab: LibraryTabId = requestedTab === 'sets' ? 'sets' : 'questions';

  const goToTab = useCallback((tab: LibraryTabId) => {
    setSearchParams(prev => {
      const next = new URLSearchParams(prev);
      next.set('tabId', tab);
      return next;
    }, { replace: true });
  }, [setSearchParams]);

  return (
    <PageOuterContainer>
      <PageHeading title='Question Library' />
      <Tabs value={activeTab} onChange={(_, v) => goToTab(v as LibraryTabId)} sx={{ mb: 1 }}>
        <Tab value='questions' label='Questions' />
        <Tab value='sets' label='Question Sets' />
      </Tabs>
      <Divider sx={{ mb: 2 }} />
      {activeTab === 'questions' && <SurveyQuestionsPage embedded />}
      {activeTab === 'sets' && <SurveyQuestionGroupsPage embedded />}
    </PageOuterContainer>
  );
};
